export default {
  row1:[
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "sionSrNo",
          label: "SION Sr No",
          component: "text-field",
        },
        {
          name: "sionIoNormSNo",
          label: "SION IONorm SNo",
          component: "text-field",
        },
        {
          name: "quantity",
          label: "Quantity",
          component: "text-field",
          dataType:"int",
        },
        {
          name:"unit",
          label:"Unit" ,        
          component: "text-field",
          endIconName:"LuSearch",
         type : "autocomplete",
         endpoint : "getQuantity"
          

        }
      ],
      row2: [
        {
          name: "itemType",
          label: "Item Type",
          component: "dropdown",
          endIconName:"LuChevronDown",
           options: [
            { label: "Indigenous", value: "Indigenous" },
            { label: "Imported", value: "Imported" },

          ],
        },

        {
          name: "itemDescription",
          label: "Item Description",
          component: "text-field",
        },
      ],
      row3: [
        {
          name: "technicalDetails",
          label: "Tech Details",
          component: "text-field",
        },
      ],
    },
  },
]
  
};
